import axios from 'axios'
import { BASE_URL, ENDPOINTS } from './endpoints'
import { clearAuth, getAuthToken } from './auth'

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: 'Basic ' + btoa('amplify:amplify')
  }
})

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken()
  config.headers = config.headers || {}
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  } else if (!config.headers.Authorization) {
    config.headers.Authorization = 'Basic ' + btoa('amplify:amplify')
  }
  return config
})

const AUTH_ERROR_PATTERNS = [
  'session expired',
  'invalid token',
  'token expired',
  'unauthorized',
  'authorised',
  'forbidden',
  'login again'
]

const isAuthErrorMessage = (value) => {
  if (!value || typeof value !== 'string') return false
  const normalized = value.toLowerCase()
  return AUTH_ERROR_PATTERNS.some((pattern) => normalized.includes(pattern))
}

const redirectToLogin = () => {
  if (typeof window === 'undefined') return
  const currentPath = `${window.location.pathname || ''}${window.location.search || ''}${window.location.hash || ''}`
  if ((window.location.pathname || '') === '/login') return
  clearAuth()
  const redirect = currentPath && currentPath !== '/' ? `?redirect=${encodeURIComponent(currentPath)}` : ''
  window.location.assign(`/login${redirect}`)
}

apiClient.interceptors.response.use(
  (response) => {
    const data = response?.data || {}
    const statusCode = response?.status
    const authLikeStatus = data?.status === 401 || data?.status === 403
    const authLikeMessage =
      isAuthErrorMessage(data?.msg) ||
      isAuthErrorMessage(data?.message) ||
      isAuthErrorMessage(data?.error)

    if (statusCode === 401 || statusCode === 403 || authLikeStatus || authLikeMessage) {
      redirectToLogin()
    }

    return response
  },
  (error) => {
    const statusCode = error?.response?.status
    const data = error?.response?.data || {}
    const authLikeStatus = data?.status === 401 || data?.status === 403
    const authLikeMessage =
      isAuthErrorMessage(data?.msg) ||
      isAuthErrorMessage(data?.message) ||
      isAuthErrorMessage(data?.error)

    if (statusCode === 401 || statusCode === 403 || authLikeStatus || authLikeMessage) {
      redirectToLogin()
    }

    return Promise.reject(error)
  }
)

const api = {  

  getVendors(formData){
     return apiClient.post(ENDPOINTS.GET_VENDORS, formData)
  }, 

  getVendorDetail(formData){
     return apiClient.post(ENDPOINTS.VENDOR_DETAIL, formData)
  },

  getVendorPackages(formData){
     return apiClient.post(ENDPOINTS.VENDOR_PACKAGES, formData)
  },

  getVendorProducts(formData){
     return apiClient.post(ENDPOINTS.VENDOR_PRODUCTS, formData)
  },

  login(formData){
     return apiClient.post(ENDPOINTS.LOGIN, formData)
  },

  loginVendor(formData){
     return apiClient.post(ENDPOINTS.LOGIN_VENDOR, formData)
  },

  register(formData){
     return apiClient.post(ENDPOINTS.REGISTER, formData)
  },

  registerVendor(formData){
     return apiClient.post(ENDPOINTS.REGISTER_VENDOR, formData)
  },

  getProfile(formData){
     return apiClient.post(ENDPOINTS.GET_PROFILE, formData)
  },

  getProfileVendor(formData){
     return apiClient.post(ENDPOINTS.GET_PROFILE_VENDOR, formData)
  },

  listBusinessVendor(formData){
     return apiClient.post(ENDPOINTS.LIST_BUSINESS_VENDOR, formData)
  },

  addBusinessVendor(formData){
     return apiClient.post(ENDPOINTS.ADD_BUSINESS_VENDOR, formData)
  },

  editBusinessVendor(formData){
     return apiClient.post(ENDPOINTS.EDIT_BUSINESS_VENDOR, formData)
  },

  updateBusinessVendor(formData){
     return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_VENDOR, formData)
  },

  updateBusinessContactVendor(formData){
     return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_CONTACT_VENDOR, formData)
  },

  updateBusinessDocumentsVendor(formData){
     return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_DOCUMENTS_VENDOR, formData)
  },

  deleteBusinessVendor(formData){
     return apiClient.post(ENDPOINTS.DELETE_BUSINESS_VENDOR, formData)
  },

  addVenue(formData){
     return apiClient.post(ENDPOINTS.ADD_VENUE, formData)
  },

  updateVenue(formData){
     return apiClient.post(ENDPOINTS.UPDATE_VENUE, formData)
  },

  deleteVenue(formData){
     return apiClient.post(ENDPOINTS.DELETE_VENUE, formData)
  },

  getSubcategories(formData){
     return apiClient.post(ENDPOINTS.GET_SUBCATEGORIES, formData)
  },

  listVendorPackages(formData){
     return apiClient.post(ENDPOINTS.LIST_VENDOR_PACKAGES, formData)
  },

  addVendorPackage(formData){
     return apiClient.post(ENDPOINTS.ADD_VENDOR_PACKAGE, formData)
  },

  deleteVendorPackage(formData){
     return apiClient.post(ENDPOINTS.DELETE_VENDOR_PACKAGE, formData)
  },

  updateVendorPackage(formData){
     return apiClient.post(ENDPOINTS.UPDATE_VENDOR_PACKAGE, formData)
  }

}

export default api
